import paths from "routes/paths";

import AbstractApiActioner from "services/cores/abstractApiActioner";
import ParkedCarsActionTypes from "./types";
import ParkedCarsApi from "./api";
import ParkedCarsUtils from "./utils";

class ParkedCarsActioner extends AbstractApiActioner {}

export default new ParkedCarsActioner(
  "ParkedCars",
  ParkedCarsActionTypes,
  ParkedCarsApi,
  ParkedCarsUtils,
  {
    paths: {
      default: paths.api.parkStatistics.dataByRadius.parkedCars,
      byAreas: paths.api.parkStatistics.dataByAreas.parkedCars,
      byRadius: paths.api.parkStatistics.dataByRadius.parkedCars,
    },
  }
);
